import { generatePath, matchPath } from "react-router-dom";

/**
 * The run page is the run's conversation (GET-4211). Owner notification links
 * (GET-4217) and the routine run history point here.
 */
export const ROUTINE_RUN_ROUTE = "/routines/:routineId/runs/:runId";

export function routineRunPath(routineId: string, runId: string): string {
  return generatePath(ROUTINE_RUN_ROUTE, { routineId, runId });
}

export function isRoutineRunPath(pathname: string): boolean {
  return matchPath(ROUTINE_RUN_ROUTE, pathname) !== null;
}
